import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  PersonasFisica,
  RPEBackPersonaFisica,
  RPEPersonaFisica
} from './entity-personas-fisica.model';

@Injectable({
  providedIn: 'root'
})
export class PersonasFisicaService {
  url: string;
  token: string;
  endpoint: string = 'personasFisica';
  endpointRPE: string = 'rpePersonasFisica';

  constructor(private http: HttpClient) {}

  getPersonasFisica(): Observable<PersonasFisica[]> {
    return this.http.get<PersonasFisica[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addPersonaFisica(personasFisica: PersonasFisica): Observable<PersonasFisica> {
    return this.http.post<PersonasFisica>(`${this.url}/${this.endpoint}/`, {
      ...personasFisica
    });
  }

  addRPEPersonaFisica(
    rpePersonaFisica: RPEPersonaFisica
  ): Observable<RPEBackPersonaFisica> {
    return this.http.post<RPEBackPersonaFisica>(
      `${this.url}/${this.endpointRPE}/`,
      {
        ...rpePersonaFisica
      }
    );
  }

  changePersonaFisica(p: PersonasFisica): Observable<PersonasFisica> {
    return this.http.patch<PersonasFisica>(
      `${this.url}/${this.endpoint}/${p.id}/`,
      {
        personasFisica: p,
        token: this.token
      }
    );
  }

  changeRPEPersonaFisica(
    p: RPEPersonaFisica
  ): Observable<RPEBackPersonaFisica> {
    return this.http.patch<RPEBackPersonaFisica>(
      `${this.url}/${this.endpointRPE}/${p.entidad_productiva.persona_fisica_id}/`,
      {
        ...p
      }
    );
  }

  deletePersonaFisica(p: PersonasFisica): Observable<PersonasFisica> {
    return this.http.delete<PersonasFisica>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
